import { Col, Card, Table } from 'reactstrap';
import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { setFormData, setFilters } from 'Services/Features/CategoryProduct/categoryProductSlice';
import { handleDelete } from 'Component/DashboardQeza/Common/DeleteUtils';
import { deleteCategoryProduct } from 'Services/Features/CategoryProduct/Utils/categoryProductUtils';
import PaginationComponent from 'Component/Common/PaginationComponent';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
const CategoryProductTable = ({ setRefetch }) => {
    const categoryProducts = useSelector((state) => state.categoryProduct.categoryProducts);
    const loading = useSelector((state) => state.categoryProduct.loading);
    const pagination = useSelector((state) => state.categoryProduct.pagination);
    const filters = useSelector(state => state.categoryProduct.filters);

        // const currentCategory = useSelector((state) => state.category.currentCategory);
    const dispatch = useDispatch();
    const history = useNavigate();


    const handleEdit = (item) => {
        console.log(item, 'handleEditItem');

        // Buat objek baru tanpa banner
        const { ...updatedItem } = item;

        dispatch(setFormData({
            ...updatedItem,
        }));

        history(`${process.env.PUBLIC_URL}/product-category/edit/${item.id}`);
    };

    return (
        <Fragment>
        <Col sm="12" lg="12" xl="8" className="mx-auto">
            <Card>
            <div className="mb-5">
                <Col sm="12" lg="12" xl="12">
                    <div className="table-responsive">
                    <Table className=" table-hover">
                        <thead className="bg-primary">
                        <tr>
                            <th scope="col" className="sticky-col-number"style={{ width: '15px' }}>{'#'}</th>
                            <th scope="col" className="sticky-col-name" style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>{'Nama Kategori Produk'}</th>
                            <th scope="col" className="text-center" style={{ width: '15px' }} >{'Aksi'}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            categoryProducts && categoryProducts.map((item, i) => 
                            <tr key={item.id}>
                                <th className="sticky-col-number" scope="row" style={{ verticalAlign: "top" }}>{i + 1}</th>
                                <td className="sticky-col-name">{item.name}</td>
                                <td>
                                <div className="d-flex">
                                    <button
                                    title="Edit"
                                    className="btn btn-primary"
                                    style={{ padding: '4px 8px', fontSize: '12px' }}
                                    onClick={() => handleEdit(item)}
                                    >
                                    <i className="fa fa-pencil"></i>
                                    </button>

                                    <button
                                    title="Hapus"
                                    className="btn btn-danger ms-2"
                                    style={{ padding: '4px 8px', fontSize: '12px' }}
                                    onClick={() => handleDelete(dispatch, item.id, setRefetch, deleteCategoryProduct)}
                                    >
                                    <i className="fa fa-trash"></i>
                                    </button>
                                </div>
                                </td>
                            </tr>
                            )
                        }
                        </tbody>
                    </Table>
                    </div>
                <div style={{ marginTop: '100px', display: 'flex', justifyContent: 'center' }}>
                    {loading === false && categoryProducts && categoryProducts.length > 0 && (
                    <PaginationComponent
                        pagination={pagination}
                        handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                        handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                        handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                    />
                    )}
                </div>
                </Col>
            </div>
            </Card>
        </Col>
        </Fragment>
    );
};

export default CategoryProductTable;